import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Оборачивает разделы, доступные только команде Data Metrics (супер-админ
 * платформы) — сейчас только "Компании". Пункт меню и так скрыт для обычных
 * клиентов (Layout.jsx), это — вторая линия защиты на случай прямого перехода
 * по URL: backend всё равно вернёт 403 на сами данные, но без этой обёртки
 * пользователь просто увидел бы пустую страницу вместо честного отказа.
 */
export default function PlatformAdminRoute({ children }) {
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  if (!user.is_platform_admin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
